<template>
    <div class="priceBox">
        <div class="dropdowm-cart-total">
            <div>
                商品小計：{{ orderHistory.totalPriceJpy.toLocaleString() }}円
                <template v-if="orderHistory.rentalPeriodRate != 1">
                    <tooltip-question text="レンタル期間が4泊5日を超えているため金額が変動しています。"/>
                </template>
            </div>
            <div v-if="!!orderHistory.discountPriceJpy">
                割引価格：<span class="text-danger">-{{ orderHistory.discountPriceJpyTax.toLocaleString() }}円</span>
            </div>
            <template>
                <span>送料(最終数量確定までは概算)：{{ orderHistory.shippingFeeDisplay }}</span>
                <span v-if="orderHistory.shippingFeeDisplay !== '未定'">円</span><br>
            </template>
            <div v-if="!!orderHistory.workingExpenses">
                <span>作業費：{{ (orderHistory.workingExpensesTax).toLocaleString() }}</span>円</div>
<!--            <div>消費税：{{ orderHistory.taxJpy.toLocaleString() }}円</div>-->
            <hr class="mt15 mb15">
            <span style="font-size: 20px;">
                合計(税込)： {{ (orderHistory.discountTotalPriceJpy).toLocaleString() }} 円
            </span>
        </div>

    </div>
</template>

<script>

import OrderHistory from "../models/OrderHistory";
import TooltipQuestion from "./TooltipQuestion";

export default {
    name: 'price-box',

    data() {
        return {

        }
    },

    props: {
        orderHistory: {
            type: OrderHistory,
            default: new OrderHistory(),
        }
    },

    created() {},

    mounted() {},

    methods: {},

    components: {
        TooltipQuestion,
    }
}
</script>

<style lang="scss" scoped>
.priceBox {
    font-size: 15px;
    color: #999;
    font-weight: bold;
    margin-bottom: 6px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/PriceBox.vue